import doubleDigitize from 'src/filters/doubleDigitize';

function formatDate(value) {
  if (!value) return '';
  const datetime = new Date(value);
  const year = datetime.getFullYear();
  const month = datetime.getMonth() + 1;
  const day = datetime.getDate();
  return `${doubleDigitize(day)}.${doubleDigitize(month)}.${year}`;
}

export default formatDate;
